import Project from '../../component/Project';
import worldTradeCentreData from '../../data/SnowPark.json';
const SnowPark = () => {
  const { pageData, containerData, content, images, styles } = worldTradeCentreData;
  return (
      <Project pageData={pageData} containerData={containerData} content={content} images={images} styles={styles} />
 )
}

export default SnowPark
